import { render, staticRenderFns } from "./fishing-page.vue?vue&type=template&id=66861d24&scoped=true&lang=pug&"
import script from "./fishing-page.vue?vue&type=script&lang=js&"
export * from "./fishing-page.vue?vue&type=script&lang=js&"
import style0 from "./fishing-page.vue?vue&type=style&index=0&id=66861d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66861d24",
  null
  
)

export default component.exports